import { useEffect, useState } from 'react'
import axios from 'axios'
import { useDialog } from '@/context/dialogContext'
import { useAppSelector } from '@/redux/hooks'
import { useAxios } from '@/context/axiosContext'

interface LikeButtonProps {
  likesYn: string // 좋아요 눌렀는지 여부
  likeCnt: number // 좋아요 수
  nttSn: number // 대상 피드백 게시글 ID
  fdbkType: string
  isMobile?: boolean
}

const LikeButton = ({
  likesYn,
  likeCnt,
  nttSn,
  fdbkType,
  isMobile,
}: LikeButtonProps) => {
  const axios = useAxios()
  const isDetailPage = location.pathname.startsWith('/feedback/detail')
  // const [liked, setLiked] = useState(likesYn === 'Y')
  const [liked, setLiked] = useState(false)
  const [count, setCount] = useState(likeCnt)
  const { isAuthenticated, user } = useAppSelector((state) => state.auth)
  const { showAlert } = useDialog()
  const [isClient, setIsClient] = useState(false) // 클라이언트 렌더링 확인용
  const [formData, setFormData] = useState({
    nttSn: nttSn,
    cstId: user?.cstId,
    fdbkType: fdbkType,
    likesYn: likesYn,
  })

  // useEffect(() => {
  //   setLiked(likesYn === 'Y')
  //   setCount(likeCnt)
  // }, [likesYn, likeCnt])

  // 클라이언트 사이드에서만 실행되도록
  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    // 인증된 사용자이고 클라이언트에서만 좋아요 상태 설정
    if (isClient && isAuthenticated) {
      setLiked(likesYn === 'Y')
    } else {
      setLiked(false) // 비로그인 상태에서는 항상 false
    }
    setCount(likeCnt)
  }, [likesYn, likeCnt, isAuthenticated, isClient])

  const toggleLike = async () => {
    if (!isAuthenticated) {
      showAlert({
        type: 'error',
        title: '로그인 후 좋아요를 눌러주세요.',
      })
      return
    }

    const newLiked = !liked
    const newCount = newLiked ? count + 1 : count - 1

    try {
      await axios.post('/feedback/like', {
        nttSn,
        cstId: user?.cstId,
        fdbkType,
        likesYn: newLiked ? 'Y' : 'N',
      })

      setLiked(newLiked)
      setCount(newCount)
    } catch (err) {
      showAlert({
        type: 'error',
        title: '좋아요 요청이 되지 않았어요.',
      })
    }
  }

  // 실제 좋아요 상태: 로그인된 사용자의 경우에만 liked 값 사용
  const shouldShowLiked = isAuthenticated && liked

  return (
    <div
      className="feedback-likes"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: isDetailPage || isMobile ? '2px' : '7px',
      }}
    >
      <div className="likes" onClick={toggleLike}>
        <svg
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          style={{ cursor: 'pointer' }}
          width={isDetailPage || isMobile ? '20' : '30'}
          height={isDetailPage || isMobile ? '20' : '30'}
        >
          <g data-name="Layer 1" id="Layer_1">
            <path
              d="M16 29s13-8.35 13-14.15c0-5.03-3.4-8.66-7.5-8.66-2.86 0-4.91 2.11-5.5 3.56-0.59-1.45-2.64-3.56-5.5-3.56-4.1 0-7.5 3.63-7.5 8.66C3 20.65 16 29 16 29z"
              // fill={liked ? '#ff0000' : 'none'}
              // stroke={liked ? 'none' : '#101820'}
              fill={shouldShowLiked ? '#ff0000' : 'none'}
              stroke={shouldShowLiked ? 'none' : '#101820'}
              strokeWidth="2"
            />
          </g>
        </svg>
      </div>
      {/* 항상 공간을 차지하도록 수정 */}
      {!isMobile && (
        <div
          className="likes-count"
          style={{
            fontSize: isDetailPage ? '15px' : '20px',
            width: isDetailPage ? '2px' : '5px', // 고정 너비
            textAlign: 'center',
            opacity: count > 0 ? 1 : 0, // 투명하게 숨김
          }}
        >
          {count}
        </div>
      )}
    </div>
  )
}

export default LikeButton
